import { RECOMMENDATION_THUMBNAIL_COLORS } from '../../constants';
import { walkthroughRecommendation } from '../../model/recommendations.service';
import { RecommendationsPreviewItem } from '../recommendations-preview/recommendations-preview-item';

export const WalkthroughRecommendationsItem = () => {
  const { id, app_product_names, content, type, created_date } =
    walkthroughRecommendation;

  return (
    <RecommendationsPreviewItem
      key={id}
      id={id}
      thumbnailFallbackColor={RECOMMENDATION_THUMBNAIL_COLORS[0]}
      programAssetId={app_product_names[0]}
      insightType={type}
      content={content}
      createdDate={created_date}
    />
  );
};
